var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.258,
    height: 21.193,
    viewBox: "0 0 28.258 21.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M21.9,79.9h1.236a.76.76,0,0,0,.706-.706V66.473a.76.76,0,0,0-.706-.706H21.9a.76.76,0,0,0-.706.706V79.189A.76.76,0,0,0,21.9,79.9Zm-10.6,0h1.236a.76.76,0,0,0,.706-.706V68.239a.76.76,0,0,0-.706-.706H11.3a.76.76,0,0,0-.706.706v10.95A.76.76,0,0,0,11.3,79.9Zm5.3,0h1.236a.76.76,0,0,0,.706-.706V71.771a.76.76,0,0,0-.706-.706H16.6a.76.76,0,0,0-.706.706v7.418A.76.76,0,0,0,16.6,79.9Zm10.773,2.649H2.649V64.883A.883.883,0,0,0,1.766,64H.883A.883.883,0,0,0,0,64.883V83.427a1.766,1.766,0,0,0,1.766,1.766H27.375a.883.883,0,0,0,.883-.883v-.883A.883.883,0,0,0,27.375,82.544ZM6,79.9H7.241a.76.76,0,0,0,.706-.706V75.3a.76.76,0,0,0-.706-.706H6A.76.76,0,0,0,5.3,75.3v3.885A.76.76,0,0,0,6,79.9Z",
    transform: "translate(0 -64)",
    className: "coloraaa svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/chart-bar.1b67330e21d37d2230201170bce0b41b.svg";
export { ForwardRef as ReactComponent };